export const MIXPANEL_API_HOST = "api-eu.mixpanel.com";
export const MIXPANEL_API_URL = `https://${MIXPANEL_API_HOST}`;
export const MIXPANEL_ENGAGE_URL = `${MIXPANEL_API_URL}/engage`;
